import { useCallback } from 'react';
import { useAddChatroomToCache, useDeleteChatroomFromCache } from '#features/chatrooms';
import type { ChatroomDataObject } from '#models/services';

type UseHandleSocketChatroomMembersParams = {
  currentUserId: string;
  onCurrentUserRemovedFromChatroom?: () => void;
};

export const useHandleSocketChatroomMembers = ({
  currentUserId,
  onCurrentUserRemovedFromChatroom,
}: UseHandleSocketChatroomMembersParams) => {
  const addChatroomToCache = useAddChatroomToCache();
  const deleteChatroomFromCache = useDeleteChatroomFromCache();

  return useCallback(
    async ({ action, socketData }: { action: 'add' | 'remove'; socketData: ChatroomDataObject }) => {
      if (action === 'remove' && !socketData.participants[currentUserId]) {
        await deleteChatroomFromCache({ chatroomId: socketData._id });
        onCurrentUserRemovedFromChatroom?.();
        return;
      }

      addChatroomToCache({ newChatroom: socketData });
    },
    [addChatroomToCache, currentUserId, deleteChatroomFromCache, onCurrentUserRemovedFromChatroom],
  );
};
